/** Please don't modify or unzip this content. It will be updated regularly **/
    (function() {
      BoostPFS.inject(this);

      //Set global variable
      Globals.hasIntegration = true;
      // 3rd app compile template
      Integration.compileIntegrationTemplate = function (data, itemHtml) {
        var ryviuMetafield = Utils.getProductMetafield(data , "ryviu" , "product_reviews_info") === null ? {} : Utils.getProductMetafield(data , "ryviu" , "product_reviews_info");var itemReviewHtml = '<div class="ryviu-collection"><ryviu-widget-total collection="1" reviews_data="' + ryviuMetafield + '" product_id="' + data.id + '" handle="' + data.handle + '"></ryviu-widget-total></div>'; itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewHtml);
        return itemHtml;
      };

      Integration.call3rdIntegrationFunc = function(data) {
        
      }

    })();